import { createContext } from 'react';


export const AuthCookieContext = createContext();